/**
 * Progress within the current level: API sends current_xp and xp_required_for_completion.
 */
export function getPointsProgressDisplay(currentXpRaw, xpRequiredRaw) {
  const cur =
    currentXpRaw != null && currentXpRaw !== "" && Number.isFinite(Number(currentXpRaw))
      ? Number(currentXpRaw)
      : 0;
  const req =
    xpRequiredRaw != null && xpRequiredRaw !== "" && Number.isFinite(Number(xpRequiredRaw))
      ? Number(xpRequiredRaw)
      : 0;

  if (req > 0) {
    const progressPercent = Math.min(100, Math.round((cur / req) * 100));
    return {
      progressPercent,
      displayNumerator: cur,
      displayDenominator: req,
      fractionLabel: `${cur}/${req}`,
    };
  }

  return {
    progressPercent: 0,
    displayNumerator: cur,
    displayDenominator: 0,
    fractionLabel: cur > 0 ? `${cur} pts` : "—",
  };
}
